import { validateEmailRegex } from '../constants/validate-email-regex.constant';

// Bare-address matcher used to EXTRACT an email out of surrounding text (no anchors,
// unlike validateEmailRegex which validates the whole string).
const EXTRACT_EMAIL_REGEX = /[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}/;

/**
 * Cleans a typed/pasted email into a bare address, or '' when none can be found.
 *
 * Email clients put name-addr strings on the clipboard — '"Knickerbocker, Craig"
 * <craig.knickerbocker@culligan.com>' — so instead of rejecting those outright, the
 * address is extracted. Also strips a leading `mailto:` and whitespace. Callers treat
 * '' as "invalid input" and block/flag; a non-empty return is always a valid address.
 */
export function normalizeEmail(raw: string): string {
    const value = (raw ?? '').trim().replace(/^mailto:/i, '');
    if (!value) return '';
    if (validateEmailRegex.test(value)) return value;
    const match = value.match(EXTRACT_EMAIL_REGEX);
    return match && validateEmailRegex.test(match[0]) ? match[0] : '';
}
